'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { LayoutDashboard, LogIn, Menu, X, Shield, Link2 } from 'lucide-react';

const navItems = [
  { label: 'Dashboard', href: '/', icon: LayoutDashboard, key: 'nav-dashboard' },
  { label: 'Shareable Links', href: '/shareable-links', icon: Link2, key: 'nav-links' },
  { label: 'Sign In', href: '/sign-up-login-screen', icon: LogIn, key: 'nav-signin' },
];

export default function TopbarNav() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      {/* Desktop nav */}
      <nav className="hidden md:flex items-center gap-1">
        {navItems?.map((item) => {
          const isActive = pathname === item?.href;
          return (
            <Link
              key={item?.key}
              href={item?.href}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-primary/15 text-primary border border-primary/25' :'text-muted-foreground hover:text-foreground hover:bg-white/5'
              }`}
            >
              <item.icon size={15} />
              {item?.label}
            </Link>
          );
        })}

        <div className="ml-3 flex items-center gap-2 pl-3 border-l border-border">
          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-primary/10 border border-primary/20">
            <Shield size={13} className="text-primary" />
            <span className="text-xs font-medium text-primary">Admin</span>
          </div>
        </div>
      </nav>
      {/* Mobile hamburger */}
      <button
        className="md:hidden p-2 rounded-lg hover:bg-white/5 transition-colors"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle navigation menu"
      >
        {mobileOpen ? <X size={20} /> : <Menu size={20} />}
      </button>
      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 glass border-b border-border py-3 px-4 flex flex-col gap-1 fade-in">
          {navItems?.map((item) => {
            const isActive = pathname === item?.href;
            return (
              <Link
                key={item?.key}
                href={item?.href}
                onClick={() => setMobileOpen(false)}
                className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? 'bg-primary/15 text-primary border border-primary/25' :'text-muted-foreground hover:text-foreground hover:bg-white/5'
                }`}
              >
                <item.icon size={16} />
                {item?.label}
              </Link>
            );
          })}
        </div>
      )}
    </>
  );
}